<template>
  <svg :width="size" :height="size" viewBox="0 0 599 600" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs v-if="sheen">
      <!-- La propia silueta recorta la banda de luz, así que el brillo solo
           aparece sobre el logotipo y no en el rectángulo que lo pasea. El
           trazado se escribe una vez (LOGO_PATH) y se usa aquí y abajo. -->
      <clipPath :id="`${uid}-clip`">
        <path :d="LOGO_PATH" />
      </clipPath>
      <!-- La banda: transparente, luz, transparente. Al ir dentro del rect, el
           degradado viaja con él. -->
      <linearGradient :id="`${uid}-sheen`" x1="0" y1="0" x2="1" y2="0">
        <stop offset="0" stop-color="#e8eaed" stop-opacity="0" />
        <stop offset="0.5" stop-color="#e8eaed" stop-opacity="0.16" />
        <stop offset="1" stop-color="#e8eaed" stop-opacity="0" />
      </linearGradient>
    </defs>

    <path :d="LOGO_PATH" :fill="color" />

    <!-- El recorte va en el grupo, que no se mueve, y la banda se pasea DENTRO.
         Puesto en el propio <rect>, el recorte se resuelve en el sistema de
         coordenadas que deja su transform: se movería con la banda y la silueta
         se iría deslizando con ella en vez de quedarse quieta. -->
    <g v-if="sheen" :clip-path="`url(#${uid}-clip)`">
      <rect
        class="logo-sheen"
        :fill="`url(#${uid}-sheen)`"
        x="0"
        y="-80"
        width="260"
        height="760"
      />
    </g>
  </svg>
</template>

<script setup lang="ts">
/**
 * El logotipo. Con `sheen`, una banda de luz le cruza la silueta cada pocos
 * segundos (el logotipo grande del hero); sin él, es el SVG de siempre, que es
 * como lo usan los cuatro de 28 px de las barras superiores.
 */
const LOGO_PATH = 'M6 180L304.5 3V80L191.5 147H304.5H413.5L526 212H304.5H72.5V530H167V248H233V530H366V244H432V530H526V212L413.5 147L304.5 80V3L592 180V596H72.5H7L6 180Z'

// Los ids de un SVG son globales de la página, y el logotipo sale más de una vez
// (hero + barra). Un contador por instancia evita que el recorte de uno se lleve
// la luz del otro.
let seq = 0

withDefaults(defineProps<{
  size?: number | string
  color?: string
  /** Pasar la banda de luz por la silueta (solo el logotipo grande). */
  sheen?: boolean
}>(), {
  size: 24,
  color: 'currentColor',
  sheen: false
})

const uid = `logo-${++seq}`
</script>

<style scoped>
/* El barrido: la banda entra por la izquierda, cruza en poco más de un segundo
   y se queda fuera del lienzo el resto del ciclo — de ahí el salto del 18 % al
   100 % en los fotogramas clave. Solo se anima `transform`, así que lo lleva el
   compositor y no repinta nada.
   Las unidades son las del viewBox (599 × 600), no píxeles de pantalla: el SVG
   las escala al tamaño al que se dibuje. */
.logo-sheen {
  animation: logo-sheen 7s ease-in-out infinite;
  will-change: transform;
}

@keyframes logo-sheen {
  0% {
    transform: skewX(-18deg) translateX(-340px);
  }
  18% {
    transform: skewX(-18deg) translateX(780px);
  }
  100% {
    transform: skewX(-18deg) translateX(780px);
  }
}

/* Quien pide menos movimiento se queda con el logotipo quieto. */
@media (prefers-reduced-motion: reduce) {
  .logo-sheen {
    display: none;
  }
}
</style>
